/** Site-wide OG fallback under `/public` when CMS share images are unset. */
export const DEFAULT_SHARE_IMAGE = "/meta-general.png";

export const SHARE_IMAGES = {
  general: DEFAULT_SHARE_IMAGE,
} as const;
